import { render, staticRenderFns } from "./AuditLogButton.vue?vue&type=template&id=f6480330&scoped=true"
import script from "./AuditLogButton.vue?vue&type=script&lang=js"
export * from "./AuditLogButton.vue?vue&type=script&lang=js"
import style0 from "./AuditLogButton.vue?vue&type=style&index=0&id=f6480330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6480330",
  null
  
)

export default component.exports